export default {
  OPEN: "open",
  Rr: "purchase",
  vr: "push_click",
  be: "custom_event",
  Ar: "iam_click",
  ks: "test"
};
